// src/data/mockProjects.ts
import { Project } from '../types';

export const mockProjects: Project[] = [
  {
    id: 'p1',
    name: 'Auditoría Laboral Q4 2025',
    clientId: 'c1',
    description: 'Auditoría completa de cumplimiento laboral para el cuarto trimestre',
    status: 'active',
    startDate: '2025-10-01T00:00:00Z',
    endDate: '2025-12-31T23:59:59Z',
  },
  {
    id: 'p2',
    name: 'Implementación SG-SST',
    clientId: 'c2',
    description: 'Implementación del Sistema de Gestión de Seguridad y Salud en el Trabajo',
    status: 'active',
    startDate: '2025-09-15T00:00:00Z',
    endDate: '2026-03-15T23:59:59Z',
  },
  {
    id: 'p3',
    name: 'Proceso de Selección Gerente TI',
    clientId: 'c1',
    description: 'Reclutamiento y selección de Gerente de Tecnología',
    status: 'completed',
    startDate: '2025-07-01T00:00:00Z',
    endDate: '2025-09-30T23:59:59Z',
  },
  {
    id: 'p4',
    name: 'Capacitación en Liderazgo',
    clientId: 'c2',
    description: 'Programa de capacitación en liderazgo para mandos medios',
    status: 'paused',
    startDate: '2025-08-01T00:00:00Z',
  },
  {
    id: 'p5',
    name: 'Actualización Reglamento Interno',
    clientId: 'c1',
    description: 'Revisión y actualización del reglamento interno de trabajo',
    status: 'active',
    startDate: '2025-11-01T00:00:00Z',
    endDate: '2025-11-30T23:59:59Z',
  },
];
